export default __webpack_public_path__ + "static/media/kbc.04f29bbe.jpg";